export enum RelatedPersonRelationshipTypes {
  Spouse = "Spouse",
  DomesticPartner = "Domestic Partner",
  SignificantOther = "Significant Other",
}
